// extracted by mini-css-extract-plugin
export default {"cardUpload":"cardUpload-WtrWW","upload":"upload-tQDQT"};